import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { merge } from 'lodash'
import toCamel from 'lodash-humps'
import { homeSlice } from '../features/home'
import { commonSlice } from '../features/common'
import { authSlice } from '../features/auth'
import { groupSlice } from '../features/group'
import { pageSlice } from '../features/page'
import { articleSlice } from '../features/article'
import { subLayoutSlice } from '../features/subLayout'
import { userSlice } from '../features/user'
import { mediaSlice, settingSlice } from '../features/media'
import { adminSlice } from '../features/admin'
import { layoutDebugMiddleware } from '../features/layoutDebug/layoutDebugMiddleware'
const slices = [
  homeSlice,
  commonSlice,
  authSlice,
  groupSlice,
  articleSlice,
  pageSlice,
  subLayoutSlice,
  userSlice,
  mediaSlice,
  settingSlice,
  adminSlice
]

const rootReducer = combineReducers({
  [homeSlice.name]: homeSlice.reducer,
  [commonSlice.name]: commonSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [groupSlice.name]: groupSlice.reducer,
  [pageSlice.name]: pageSlice.reducer,
  [articleSlice.name]: articleSlice.reducer,
  [subLayoutSlice.name]: subLayoutSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [mediaSlice.name]: mediaSlice.reducer,
  [settingSlice.name]: settingSlice.reducer,
  [adminSlice.name]: adminSlice.reducer
})

export const setupStore = (initialState: Record<string, unknown>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(layoutDebugMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: slices.reduce(
      (result, slice) => merge(result, { [slice.name]: slice.getInitialState() }),
      toCamel(initialState)
    )
  })
}

export type AppStore = ReturnType<typeof setupStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
